const colors = {
  red: '#be4b15',
  green: '#52ce60',
  blue: '#6ea5f8',
  lightred: '#fd8852',
  lightblue: '#afd4fe',
  lightgreen: '#b9e986',
  teal: '#10BABC',
  brightteal: '#00cdcd',
  pink: '#faadc1',
  purple: '#d689ff',
  orange: '#fdb400',
  grey: '#a3a3a3',
  darkgrey: '#252525',
  black: '#191919',
  gunmetal: '#2a3439',
  offwhite: '#FAF9F6',
  white: '#ffffff',
};

export default colors;
